import { render, staticRenderFns } from "./ShowClient.vue?vue&type=template&id=1de15a44&scoped=true"
import script from "./ShowClient.vue?vue&type=script&lang=js"
export * from "./ShowClient.vue?vue&type=script&lang=js"
import style0 from "./ShowClient.vue?vue&type=style&index=0&id=1de15a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de15a44",
  null
  
)

export default component.exports